export default {
  线索商户: "线索商户",
  商户ID: "商户ID",
  入驻邮箱: "入驻邮箱",
  联系电话: "联系电话",
  授权店铺: "授权店铺",
  报名商品数: "报名商品数",
  TAP合作店铺: "TAP合作店铺",
  TAP合作商品数: "TAP合作商品数",
  TAP申样数: "TAP申样数",
  来源: "来源",
  跟进: "跟进",
  自主入驻: "自主入驻",
  跟进商户: "跟进商户",
  跟进人: "跟进人",
  供应链名称: "供应链名称",
  "该店铺已绑定其他供应链，不可重复绑定！": "该店铺已绑定其他供应链，不可重复绑定！",
  供应链ID: "供应链ID",
  跟进联系方式: "跟进联系方式",
  联系邮箱: "联系邮箱",
  "Youpik Grow联系电话": "Youpik Grow联系电话",
  店铺名称: "店铺名称",
  店铺号: "店铺号",
  是: "是",
  否: "否",
  店铺商品数: "店铺商品数",
  店铺GMV: "店铺GMV",
  店铺销量: "店铺销量",
  店铺总订单: "店铺总订单",
  SKU订单: "SKU订单",
  订单均价: "订单均价",
  "该店铺已授权至供应链，不可操作更改！": "该店铺已授权至供应链，不可操作更改！",
  入驻状态: "入驻状态",
  未入驻: "未入驻",
  已入驻: "已入驻",
  复制入驻链接: "复制入驻链接",
  该商户已入驻: "该商户已入驻",
  "Youpik Grow账号详情": "Youpik Grow账号详情",
  查看: "查看",
  入驻时间: "入驻时间",
  申样等待处理: "申样等待处理",
  未处理样品申请: "未处理样品申请",
  超过24hr未处理: "超过24hr未处理",
  最后一次申样日期: "最后一次申样日期",
  发货链接: "发货链接",
  跟进时间: "跟进时间",
  查看发货详情: "查看发货详情",
  复制发货链接: "复制发货链接",
  编辑: "编辑",
  商家TAP活动配置: "商家TAP活动配置",
  活动ID: "活动ID",
  活动名称: "活动名称",
  活动状态: "活动状态",
  进行中: "进行中",
  邀约中: "邀约中",
  待邀约: "待邀约",
  不可邀约: "不可邀约",
  已结束: "已结束",
  报名时间: "报名时间",
  活动时间: "活动时间",
  邀约状态: "邀约状态",
  "进行中的联盟营销活动会在Youpik Grow公开展示给所有商家。": "进行中的联盟营销活动会在Youpik Grow公开展示给所有商家。",
  "活动进行中，还未展示给商家。": "活动进行中，还未展示给商家。",
  "活动结束，无法展示给商家": "活动结束，无法展示给商家",
  佣金要求: "佣金要求",
  公开佣金: "公开佣金",
  Youpik佣金: "Youpik佣金",
  达人附加佣金: "达人附加佣金",
  "商家在TikTok公开给达人的佣金%": "商家在TikTok公开给达人的佣金%",
  "与Youpik合作，商家支付给Youpik的营销佣金。": "与Youpik合作，商家支付给Youpik的营销佣金。",
  "在公开佣金之上，商家需支付给达人的额外佣金加成%": "在公开佣金之上，商家需支付给达人的额外佣金加成%",
  寄样要求: "寄样要求",
  必须: "必须",
  非必须: "非必须",
  编辑要求: "编辑要求",
  暂停邀约: "暂停邀约",
  "在Youpik Grow商家后台暂停邀约该活动": "在Youpik Grow商家后台暂停邀约该活动",
  "Youpik Grow商家后台将不再展示该活动，你还要继续吗？": "<span style='color: red'>Youpik Grow商家后台将不再展示该活动</span>，你还要继续吗？",
  请设置该活动报名需满足的要求: "请设置该活动报名需满足的要求",
  加入邀约: "加入邀约",
  注册来源: "注册来源",
  注册邮箱: "注册邮箱",
  是否合作TAP: "是否合作TAP",
  全部: "全部",
  待发布: "待发布",
  即将开始: "即将开始",
  "仅商家运营可操作！": "仅商家运营可操作！",
  佣金范围错误: "佣金范围错误",
  商家BD邀请: "商家BD邀请",
  "复制成功，请勿将链接发送给错误商家！": "复制成功，请勿将链接发送给错误商家！",
}